import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Menu-tw-styles';
import MenuList from './MenuList';
import MenuListDT from './MenuListDT';
import Typography from '../../Generic/Typography';
import { getCdnImage } from '../../../utils/ImageManager';
import { Button } from '../../Generic/Button';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import ALP_Constants from '../../Brand/ArticleListingPage/constants';

export default function MenuItem(props) {
  const {
    menuSlot,
    changeActiveSlot,
    resetSlot,
    resetMenu,
    slotIndex,
    activeSlotIndex,
    changeActiveMenu,
  } = props;

  // Focus main close button when third-level panel opens
  React.useEffect(() => {
    if (slotIndex === activeSlotIndex && activeSlotIndex !== -1) {
      // Panel is now open, focus the main menu close button
      setTimeout(() => {
        const panel = document.getElementById(`submenu-panel-${slotIndex}`);
        if (panel) {
          // Find the main dropdown container and its close button
          const mainDropdown = panel.closest('.activeMenuWrapper') || 
                              panel.closest('[role="menu"]') ||
                              document.querySelector('.activeMenuWrapper');
          if (mainDropdown) {
            const closeButton = mainDropdown.querySelector('.header-dropdown-close');
            if (closeButton && typeof closeButton.focus === 'function') {
              closeButton.focus();
            }
          }
        }
      }, 100);
    }
  }, [activeSlotIndex, slotIndex]);

  return (
    <React.Fragment>
      {/* for desktop */}
      <li className={classNames(styles.menuSlotWrapper, menuSlot.styles)}>
        <div
          className={
            menuSlot.linkButtonCollection &&
            menuSlot.linkButtonCollection.items &&
            menuSlot.linkButtonCollection.items.length > 0
              ? styles.menuSlotHeader
              : styles.menuSlotNonBold
          }
        >
          <Button
            className={classNames(styles.menuSlotLink)}
            to={menuSlot.link}
            tabIndex={activeSlotIndex !== -1 ? -1 : 0}
          >
            {menuSlot.title}
          </Button>
        </div>
        {menuSlot && menuSlot.image && (
          <div className={styles.menuImageWrapperContainer}>
            {menuSlot.image && (
              <div className={styles.menuImageWrapper}>
                <img
                  src={getCdnImage(menuSlot.image.url)}
                  className={styles.menuImage}
                  alt=""
                />
              </div>
            )}
            <div>
              {menuSlot && menuSlot.text && (
                <Typography
                  component="div"
                  className={classNames(styles.subMenuListText)}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(menuSlot.text),
                  }}
                />
              )}
              <div>
                {menuSlot.linkButtonCollection &&
                menuSlot.linkButtonCollection.items &&
                menuSlot.linkButtonCollection.items.length > 0 ? (
                  <Button
                    to={menuSlot.linkButtonCollection.items[0].link}
                    className={classNames(styles.menuSlotButton)}
                    key={menuSlot.linkButtonCollection.items[0].sys.id}
                    title={menuSlot.linkButtonCollection.items[0].tooltip}
                    tabIndex={0}
                  >
                    {menuSlot.linkButtonCollection.items[0].linkText}
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
        )}
        {menuSlot.menuItemsCollection &&
          menuSlot.menuItemsCollection.items.length > 0 && (
            <div className={styles.subMenuWrapper}>
              <ul>
                <MenuListDT menuSlots={menuSlot} resetMenu={resetMenu} />
              </ul>
            </div>
          )}
      </li>
      {/* for mobile */}
      <li className={styles.menuSlotWrapperMobile}>
        {/* start- has only 2nd level */}
        {menuSlot.menuItemsCollection &&
        menuSlot.menuItemsCollection.items.length === 0 ? (
          <div className={styles.menuSlotHeader}>
            <Button
              className={classNames(
                styles.menuSlotMobileLink,
                styles[menuSlot.styles]
              )}
              to={menuSlot.link}
              onClick={resetSlot}
              tabIndex={0}
            >
              {menuSlot.title}
            </Button>
            {menuSlot.image && (
              <img
                src={getCdnImage(menuSlot.image.url)}
                className={styles.menuSlotImage}
                alt={menuSlot.title}
              />
            )}
            <span />
            {/* end-  2nd level content with no third level*/}
          </div>
        ) : (
          <div className={styles.menuSlotHeader}>
            {/* start- 2nd level which has 3rd level */}
            {menuSlot.menuItemsCollection &&
              menuSlot.menuItemsCollection.items.length !== 0 && (
                <Button
                  className={styles.menuSlotMobileLink}
                  aria-expanded={
                    slotIndex === activeSlotIndex ? 'true' : 'false'
                  }
                  aria-controls={`submenu-panel-${slotIndex}`}
                  aria-label={menuSlot.title}
                  onClick={() => {
                    changeActiveSlot(slotIndex);
                  }}
                  tabIndex={activeSlotIndex !== -1 ? -1 : 0}
                >
                  <span>{menuSlot.title}</span>
                  <span className={styles.rightArrow} aria-hidden="true" />
                </Button>
              )}
          </div>
        )}
      </li>
      <div
        id={`submenu-panel-${slotIndex}`}
        className={classNames(
          styles.subMenuWrapper,
          slotIndex === activeSlotIndex
            ? styles.subMenuOpen
            : styles.subMenuClose
        )}
        aria-hidden={slotIndex === activeSlotIndex ? 'false' : 'true'}
      >
        {/* start-  3rd level content*/}
        <div className={classNames(styles.menuDropdownContainer)}>
          {/* Menu title and items */}
          <Typography
            component="div"
            className={classNames(styles.menuItemHeader)}
          >
            {menuSlot.title}
          </Typography>
          <ul className={classNames(styles.ulMenuList)} role="presentation">
            <MenuList menuSlots={menuSlot} resetMenu={resetMenu} />
          </ul>
          {/* Back button at the bottom - last in tab order */}
          {menuSlot.menuItemsCollection &&
            menuSlot.menuItemsCollection.items.length !== 0 && (
              <Button
                className={classNames(
                  styles.leftArrow,
                  'header-dropdown-left-arrow',
                  'moblie-back-button',
                  'lg:hidden'
                )}
                aria-label="Fechar o Submenu ou voltar"
                tabIndex={0}
                onClick={() => {
                  changeActiveSlot(slotIndex);
                }}
              >
                {''}
              </Button>
            )}
          {/* end-  3rd level content*/}
        </div>
      </div>
    </React.Fragment>
  );
}

MenuItem.propTypes = {
  menuSlot: PropTypes.oneOfType([PropTypes.object]).isRequired,
  slotIndex: PropTypes.number.isRequired,
  changeActiveSlot: PropTypes.func.isRequired,
  changeActiveMenu: PropTypes.func.isRequired,
  resetSlot: PropTypes.func.isRequired,
  resetMenu: PropTypes.func.isRequired,
  activeSlotIndex: PropTypes.number,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const MenuItem = ({prop = val, activeSlotIndex = 0 }) =>
